var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ml-table',{attrs:{"columns":_vm.tableColumns,"data-source":_vm.tableData,"scroll":{x: (this.tableColumns.length + 1) * 110, y: _vm.scrollHeight}}})}
var staticRenderFns = []

export { render, staticRenderFns }